<template>
  <div class="cl-inner">
    <!-- 搜索 -->
    <div class="search-inner">
      <a-form layout="inline">
        <a-form-item class="name" label="学期">
          <a-select
            showSearch
            placeholder="请选择"
            :filterOption="false"
            :defaultActiveFirstOption="false"
            style="width: 200px"
            @search="changeTerm"
            v-model="queryParam.termId"
            :allowClear="true"
          >
            <a-select-option
              v-for="(item, index) in termList"
              :key="index"
              :value="item.id"
              >{{ item.termName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <!-- 提交时间 -->
        <a-form-item label="提交时间">
          <a-range-picker
          :showTime="{ defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')] }"
            format="YYYY-MM-DD HH:mm:ss"
            :placeholder="['开始时间', '结束时间']"
            @change="onChange"
            v-model="queryParam.selectTime"
          />
        </a-form-item>

        <!-- 退款单号 -->
        <a-form-item class="name" label="退款单号">
          <a-input
            class="form-cell"
            type="text"
            placeholder="请输入"
            :allowClear="true"
            v-model="queryParam.outRefundNo"
          ></a-input>
        </a-form-item>
        <a-form-item class="name" label="支付单号">
          <a-input
            class="form-cell"
            type="text"
            placeholder="支付结果中商户单号"
            :allowClear="true"
            v-model="queryParam.transId"
          ></a-input>
        </a-form-item>
        <!-- 订单号 -->
        <a-form-item class="name" label="订单号">
          <a-input
            class="form-cell"
            type="text"
            placeholder="请输入"
            :allowClear="true"
            v-model="queryParam.orderNo"
          ></a-input>
        </a-form-item>

        <!-- 订单类型 -->
        <a-form-item class="name" label="订单类型">
          <a-select
            class="form-cell"
            placeholder="请选择"
            v-model="queryParam.orderType"
            :allowClear="true"
          >
            <a-select-option value="1">班级</a-select-option>
            <a-select-option value="2">活动</a-select-option>
            <a-select-option value="3">账单</a-select-option>
          </a-select>
        </a-form-item>

        <!-- 退款状态 -->
        <a-form-item class="name" label="退款状态">
          <a-select
            class="form-cell"
            placeholder="请选择"
            v-model="queryParam.status"
            :allowClear="true"
          >
            <a-select-option value="1">审核中</a-select-option>
            <a-select-option value="2">退款成功</a-select-option>
            <a-select-option value="3">退款失败</a-select-option>
            <a-select-option value="4">已取消</a-select-option>
          </a-select>
        </a-form-item>

        <!-- 站点 -->
        <a-form-item
          class="name"
          label="站点"
          v-if="roleId != '3' && roleId != '4'"
        >
          <a-select
            showSearch
            placeholder="请输入"
            :filterOption="false"
            :defaultActiveFirstOption="false"
            @search="changeBureauName"
            style="width: 200px"
            v-model="queryParam.bureauId"
            :allowClear="true"
          >
            <a-select-option
              v-for="(item, index) in bureauList"
              :key="index"
              :value="item.id"
              >{{ item.bureauName }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <!-- 学校 教育局和平台管理员才有-->
        <c-school-select
          v-if="roleId && roleId != '3'"
          :schoolCode.sync="queryParam.schoolId"
        ></c-school-select>

        <!-- 课程方 -->
        <c-institution-select
          v-if="roleId && roleId != '4'"
          :institutionCode.sync="queryParam.institutionId"
        ></c-institution-select>

        <!-- 学生 -->
        <a-form-item class="name" label="学生">
          <a-input
            class="form-cell"
            type="text"
            placeholder="请输入"
            :allowClear="true"
            v-model="queryParam.studentName"
          ></a-input>
        </a-form-item>

        <!-- 订单标题 -->
        <a-form-item class="name" label="订单标题">
          <a-input
            class="form-cell"
            type="text"
            placeholder="请输入"
            :allowClear="true"
            v-model="queryParam.orderTitle"
          ></a-input>
        </a-form-item>

        <!-- 来源 -->
        <a-form-item class="name" label="来源" v-if="roleId != '4'">
          <a-select
            class="form-cell"
            placeholder="请选择"
            v-model="queryParam.offeringType"
            :allowClear="true"
            @change="offeringTypeChange"
          >
            <a-select-option value="1">学校</a-select-option>
            <a-select-option value="2">课程方</a-select-option>
          </a-select>
        </a-form-item>
        <!--------------------  课程方种类 -->
        <a-form-item class="name" label="课程方种类" v-if="roleId != '4'">
          <a-select
            :disabled="!(queryParam.offeringType == 2)"
            class="form-cell"
            placeholder="请选择"
            :allowClear="true"
            v-model="queryParam.institutionType"
          >
            <a-select-option value="3">高校与协会</a-select-option>
            <a-select-option value="1">社会企业</a-select-option>
            <a-select-option value="2">个人老师</a-select-option>
          </a-select>
        </a-form-item>

        <!-- 金额区间 -->
        <a-form-item label="金额区间：" class="w100">
          <a-input-group compact style="width: 100%">
            <a-input-number
              style="width: calc((100% - 30px) / 2)"
              placeholder="最低价"
              :min="0"
              :precision="2"
              v-model="startPrice"
            />
            <a-input
              style="
                width: 30px;
                border-left: 0;
                pointer-events: none;
                backgroundcolor: #fff;
              "
              placeholder="~"
              disabled
            />
            <a-input-number
              style="width: calc((100% - 30px) / 2); border-left: 0"
              :min="0"
              :precision="2"
              placeholder="最高价"
              v-model="endPrice"
            />
          </a-input-group>
        </a-form-item>

        <a-form-item class="search-oper">
          <a-button type="primary" @click="searchRefund()">查询</a-button>
          <a-button type="primary" @click="clearSelect()">重置</a-button>
          <a
            title="导出限制为10000条，超出限制导出请联系技术支持"
            class="download hover-font-active"
            @click="exportStudent"
            >导出</a
          >
        </a-form-item>
      </a-form>
    </div>

    <!-- 表格数据 -->
    <a-table
      :columns="columns"
      :dataSource="refundList"
      :rowKey="(record) => record.id"
      class="c-table"
      :pagination="pagination"
      :loading="loading"
      @change="tableChange"
    >
      <span slot="outRefundNo" slot-scope="text, record">
        {{ record.outRefundNo }}
        <span class="cross" v-if="record.isCrossSchool == 1">
          <img src="/crossSchool.png" style="width: 16px" alt="" />
          <em>跨校订单</em>
        </span>
      </span>
      <span slot="className" slot-scope="text">
        {{ text ? text : '- -' }}
      </span>
      <span slot="providerName" slot-scope="text">
        {{ text ? text : '- -' }}
      </span>
      <span slot="offeringTypeText" slot-scope="text">
        {{ text ? text : '无' }}
      </span>
      <span slot="totalPrice" slot-scope="text">
        {{ text | price }}
      </span>
      <span slot="applyRefundFee" slot-scope="text">
        {{ text | price }}
      </span>
      <span slot="refundFee" slot-scope="text">
        {{ text | price }}
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="$refs.refundDetail.init(record)">查看</a>
          <template
            v-if="
              record.status == '1' &&
              ((roleId == '3' && record.offeringType == '1') || roleId == '4')
            "
          >
            <a-divider type="vertical" />
            <a @click="$refs.refundForm.init(record)">审核</a>
          </template>
        </template>
      </span>
      <span slot="providerName" slot-scope="text, record">
        <template>
          <span
            >{{ record.providerName }}
            <a-tag v-if="record.institutionType == 3" color="blue">
              高协
            </a-tag></span
          >
        </template>
      </span>
    </a-table>
    <refund-form-modal ref="refundForm"></refund-form-modal>
    <refund-detail ref="refundDetail"></refund-detail>
  </div>
</template>
<script>
import refund from '../../api/refund'

import bureau from '../../api/bureau'

import school from '../../api/school'

import finOrder from '../../api/finOrder'

import RefundFormModal from './components/RefundFormModal'

import RefundDetail from './components/RefundDetail'

import CSchoolSelect from '../../components/CSchoolSelect'

import CInstitutionSelect from '../../components/CInstitutionSelect'

import moment from 'moment'
import Vue from 'vue'
export default {
  name: 'refundList',
  data() {
    return {
      refundList: [], //退款数据
      columns: [
        {
          title: '退款单号',
          dataIndex: 'outRefundNo',
          scopedSlots: { customRender: 'outRefundNo' },
          width: 200,
        },
        {
          title: '退款状态',
          dataIndex: 'statusText',
          width: 60,
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          width: 160,
        },
        {
          title: '订单名称',
          dataIndex: 'orderTitle',
          width: 90,
        },
        {
          title: '订单类型',
          dataIndex: 'orderTypeText',
          width: 60,
        },
        {
          title: '课程名称',
          dataIndex: 'className',
          scopedSlots: { customRender: 'className' },
          width: 70,
        },
        {
          title: '提供方',
          dataIndex: 'providerName',
          scopedSlots: { customRender: 'providerName' },
          width: 75,
          scopedSlots: {
            customRender: 'providerName',
          },
        },
        {
          title: '站点',
          dataIndex: 'bureauName',
          width: 110,
        },
        {
          title: '学校',
          dataIndex: 'schoolName',
          width: 75,
        },
        {
          title: '学生',
          dataIndex: 'studentName',
          width: 78,
        },

        {
          title: '来源',
          dataIndex: 'offeringTypeText',
          scopedSlots: { customRender: 'offeringTypeText' },
          width: 60,
        },
        {
          title: '课程方种类',
          dataIndex: 'institutionTypeName',
          width: 60,
        },
        {
          title: '订单总价/元',
          dataIndex: 'totalPrice',
          scopedSlots: { customRender: 'totalPrice' },
          width: 80,
        },
        {
          title: '申请退款总价/元',
          dataIndex: 'applyRefundFee',
          scopedSlots: { customRender: 'applyRefundFee' },
          width: 90,
        },
        {
          title: '实际退款总价/元',
          dataIndex: 'refundFee',
          scopedSlots: { customRender: 'refundFee' },
          width: 80,
        },
        {
          title: '提交时间',
          dataIndex: 'gmtCreate',
          sorter: true,
          width: 120,
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: 106,
        },
      ],
      startPrice: '', //最小价格
      endPrice: '', //最大价格
      queryParam: {}, //查询参数
      pagination: {
        pageSize: 10,
        total: 0,
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
        current: 1,
        currentPage: 1,
      }, //分页数据对象
      loading: true, //状态loading加载
      classNameList: [], //班级搜索的集合
      bureauList: [], //站点的集合
      value: undefined,
      roleId: '', //权限id
      termList: [],
    }
  },
  components: {
    RefundFormModal,
    RefundDetail,
    CSchoolSelect,
    CInstitutionSelect,
  },
  methods: {
    moment,
    offeringTypeChange(value) {
      console.log('value', value)
      if (value == 1) {
        this.queryParam.institutionType = undefined
      }
    },
    //导出
    exportStudent(e) {
      let _this = this;
      this.$confirm({
        title: '注意',
        okText: '确定',
        cancelText: '取消',
        icon:'exclamation-circle',
        content: '注意：仅支持导出1万条数据记录，如需导出更多数据请提出人工导出申请',
        onOk() {
          _this.$message.success('导出中...')
      refund.exportRefund(_this.queryParam).then((res) => {
        const url = window.URL.createObjectURL(res.data)
        let dom = document.createElement('a')
        dom.style.display = 'none'
        dom.href = url
        dom.setAttribute('download', '退款列表.xlsx')
        document.body.appendChild(dom)
        dom.click()
      })
        },
      })
    },

    //table发生该表，分页，排序
    tableChange(pagination, filters, sorter) {
      let obj = this.queryParam
      obj.currentPage = pagination.current
      obj.pageSize = pagination.pageSize
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        obj
      )}`
      //存在排序的时候
      if (sorter && sorter.columnKey) {
        obj.sorter = `${sorter.columnKey}-${
          sorter.order == 'ascend' ? 'asc' : 'desc'
        }`
      }
      this.getRefundList(obj)
    },

    //选择时间改变触发
    onChange(value, dateString) {
      //赋值筛选时间
      this.queryParam.minGmtCreate = dateString[0]
      this.queryParam.maxGmtCreate = dateString[1]
    },

    //重置
    clearSelect() {
      this.queryParam = {}
      this.startPrice = ''
      this.endPrice = ''
      //查询退款列表
      this.getRefundList()
    },
    //查询退款列表
    searchRefund() {
      console.log('this.queryParam', this.queryParam)
      var queryParams = JSON.parse(JSON.stringify(this.queryParam))
      delete queryParams.selectTime
      queryParams.currentPage = 1
      queryParams.pageSize = 10
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        queryParams
      )}`
      if (this.startPrice == '' && this.endPrice == '') {
        this.getRefundList(queryParams)
      } else {
        if (this.startPrice > this.endPrice) {
          this.$message.error('最低价不能大于最高价')
        } else {
          this.queryParam.startPrice = this.startPrice * 100
          this.queryParam.endPrice = this.endPrice * 100
          queryParams.startPrice = Math.round(this.startPrice * 100)
          queryParams.endPrice = Math.round(this.endPrice * 100)
          this.getRefundList(queryParams)
        }
      }
    },

    //退款列表接口方法
    getRefundList(params) {
      this.loading = true
      refund.getRefundList(params).then((res) => {
        this.refundList = res.data.list
        this.loading = false
        //分页信息
        this.pagination = res.data.pagination
      })
    },

    //刷新退款列表
    refreshRefund() {
      this.getRefundList()
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    changeTerm(value) {
      this.value = value
      this.queryParam.termId = value
    },
    //查询站点
    changeBureauName(value) {
      value = value ? value.trim() : ''
      let self = this
      let req = {
        bureauName: value,
      }
      bureau.selectBureau(req).then((res) => {
        self.bureauList = res.data
      })
    },
    //是否有操作权限
    judgeIsOper() {
      this.$store.dispatch('getUserInfo').then(async (res) => {
        this.roleId = res.accRole.id.toString()
        //学校
        if (this.roleId == '3') {
          this.columns.splice(7, 2)
        } else if (this.roleId == '4') {
          this.columns.splice(5, 3)
        } else if (this.roleId == '6') {
          if (!this.$route.query.params) {
            await school.searchSchool({ schoolName: '' }).then((res) => {
              this.queryParam.schoolId = res.data[0].id
            })
          }
        }
        this.getRefundList(this.queryParam)
      })
    },
  },

  created() {
    if (this.$route.query.params) {
      this.queryParam = JSON.parse(this.$route.query.params)
    } else {
      this.queryParam = {}
    }
    this.termList = Vue.ls.get('term')
    //查询退款列表
    this.changeBureauName()
    this.judgeIsOper()
    // this.getRefundList(this.queryParam)
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}

.search-oper {
  button {
    margin: 0px 5px;
  }
}

.list-oper {
  margin: 20px 0px 30px;
}

.person-scope {
  width: 100px;
  text-align: center;
}

.max-person {
  border-left: none;
}

.c-table {
  margin-top: 20px;
}

.person-gap {
  width: 30px;
  border-left: 0;
  pointer-events: none;
  background: #fff;
}
.download {
  display: inline-block;
  margin-left: 20px;
  text-decoration: underline;
  color: $primary-color-dark;
  position: relative;
}
.cross {
  margin-left: 5px;
  color: #d71616 !important;
  // img {
  //   margin-bottom: 2px;
  // }
  em {
    border: 1.5px solid #d71616;
    border-radius: 4px;
    margin-left: 2px;
    font-style: normal;
  }
}
</style>
